// Токен отправляется первым сообщением; URL не содержит учётные данные.
export function staffSocketUrl(path, location = window.location) {
  if (!/^\/(?!\/)/.test(path)) throw new Error('Ожидается путь WebSocket внутри приложения');
  const local = ['localhost', '127.0.0.1'].includes(location.hostname);
  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = local ? 'localhost:8002' : location.host;
  return `${protocol}//${host}${path}`;
}

export function openStaffSocket(path) {
  const socket = new WebSocket(staffSocketUrl(path));
  socket.addEventListener('open', () => {
    socket.send(JSON.stringify({ type: 'auth', token: localStorage.getItem('token') || '' }));
  }, { once: true });
  return socket;
}
